import React from 'react'
import styled from 'styled-components'

import { Row, Col } from '@zendeskgarden/react-grid'

const StyledLogo = styled.img`
  height: 100px
  width: 100px
`

const HrDiv = styled.div`
  height: 1px
  background-color: #ccc
  text-align: center
  margin-top: 10px
  margin-bottom: 10px
  transform: translate(0px, 39px)
`

const ContactUs = styled.a`
  float: right!important
  padding-left: 14px
  padding-right: 14px
`

const FooterRow = styled.div`
  top: -200px
  padding-bottom: 20px
  padding-left: 10px
  padding-right: 10px
  padding-top: 0
`

const FeedbackDiv = styled.div`
  background-color: #f3f0ee;
  margin: 40px 0 40px 0;

  h2 {
    color: $zd-color-algae;
    font: normal 300 28px sharpsans,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Oxygen-Sans,Arial,sans-serif;
    font-weight: 500;
    padding: 40px 0 40px 0;
  }

  a {
    color: $zd-color-explore;
    display: block;
  }
`

const Center = {
  textAlign: 'center'
}

const FeedbackSection = () => {
  return (
    <div style={Center}>
      <h2>Having an issue that is not reported above? <a href="https://support.zendesk.com/hc/en-us/articles/4408843597850" target="_blank" rel="noopener noreferrer">Tell&nbsp;us.</a></h2>
    </div>
  )
}

const StatusPageFooter = () => {
  return (
    <Col id="footer" justifyContent="center">
      <FeedbackDiv>
        <FeedbackSection/>
      </FeedbackDiv>
      <Row justifyContent="center" >
        <Col md={5} justifyContent="start">
          <HrDiv/>
        </Col>
        <Col md={2}>
          <Row justifyContent="center">
            <Col md={3}>
            </Col>
            <Col md={15} justifyContent="center">
              <StyledLogo src="img/fistbump_svg.svg" />
            </Col>
            <Col md={3}>
            </Col>
          </Row>
        </Col>
        <Col md={5} justifyContent="end">
          <HrDiv/>
        </Col>
      </Row>
      <FooterRow>
        <Row>
          <Col md={5}>
            <Row>
              <Col md={3}>
                <a href="https://www.zendesk.com/company/privacy" target="__blank">Privacy Policy</a>
              </Col>
              <Col md={3}>
                <a href="https://www.zendesk.com/company/cookies" target="__blank">Cookie Policy</a>
              </Col>
              <Col md={3}>
                <a href="https://www.zendesk.com/company/terms" target="__blank">Terms & Conditions</a>
              </Col>
              <Col md={3}>
                <a href="https://www.zendesk.com/company/terms" target="__blank">{`© Zendesk ${  new Date().getFullYear()}`}</a>
              </Col>
            </Row>
          </Col>
          <Col md={7}>
            <ContactUs target="_blank" href="https://www.zendesk.com/support/contact/" rel="noopener noreferrer">Contact us</ContactUs>
          </Col>
        </Row>
      </FooterRow>
    </Col>
  )
}

export default StatusPageFooter
